import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import mapReducers from '../reducers/map-reducers';
import modalReducers from '../reducers/modal-reducers';
import parameterReducers from '../reducers/parameter-reducers';
import songsReducers from '../reducers/songs-reducers';


const combinedReducers = combineReducers({
	mapReducers, 
	modalReducers, 
	parameterReducers, 
	// playlistReducers, 
	songsReducers, 
	// submitNewSongReducers
});

const store = createStore(
	combinedReducers
);
// initialiseSagaMiddleware.run(apiSaga);
export default store;